import { render, staticRenderFns } from "./CreateLogin.vue?vue&type=template&id=65d0a3fe&"
import script from "./CreateLogin.vue?vue&type=script&lang=js&"
export * from "./CreateLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports